module.exports = __webpack_public_path__ + "img/banner2.956747b1.png";